export default "__VITE_ASSET__Brvqu$Wq__"